<template>
  <div class="grid__container">
    <div class="grid__content">
      <div class="grid__list">
        <div
          v-for="(_, index) in items"
          :key="index"
          :class="{
            'grid__list-item': true,
            'grid__list-horizontal-item': isHorizontalItem(index),
            'grid__list-inverted-item': !isHorizontalItem(index) && isInvertedRow(index)
          }"
        >
          <div class="grid__list-item-text">
            <Heading size="h3">
              {{ $t(`${itemKeys}[${index}].title`) }}
            </Heading>
            <Paragraph size="large">
              <i18n
                :path="`${itemKeys}[${index}].description`"
              >
                <template #link>
                  <Link :href="descriptionUrls[index]" target="_blank">
                    {{ $t(`${itemKeys}[${index}].link`) }}
                  </Link>
                </template>
              </i18n>
            </Paragraph>
          </div>
          <img
            :src="imagesPath[index]"
            :srcset="`${imagesPath[index].replace(/(\.png)$/, '@2x$1')} 2x`"
            class="grid__list-item-image"
            :alt="$t(`${itemKeys}[${index}].alt_image`)"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Heading from '@/components/common/Heading/Heading'
import Paragraph from '@/components/common/Paragraph/Paragraph'
import Link from '@/components/common/Link/Link'

export default {
  components: {
    Heading,
    Paragraph,
    Link
  },

  props: {
    itemKeys: {
      type: String,
      required: true
    },
    descriptionUrls: {
      type: Array,
      default: () => []
    },
    imagesPath: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    items () {
      return this.$t(this.itemKeys)
    }
  },

  methods: {
    isHorizontalItem (index) {
      return this.items.length - 1 === index && this.items.length % 2 === 1
    },

    isInvertedRow (index) {
      const mod = index % 4
      return mod !== 0 && mod !== 1
    }
  }
}
</script>

<style lang="scss" scoped>
.grid {
  &__container {
    background-color: #25163A;
    padding: $gap * 2 $gap;

    @include display-less(desktop) {
      padding: $gap * 5 $gap;
    }
  }

  &__content {
    max-width: 1120px;
    margin: 0 auto;

  }

  &__list {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto;
    gap: $gap * 2.5;

    @include display-less(desktop) {
      display: flex;
      flex-direction: column;
      gap: $gap * 2.5;
    }

    &-item {
      display: flex;
      flex-direction: column;
      gap: $gap * 1.5;
      justify-content: space-around;
      padding: $gap * 2.5 0;
      border-radius: 16px;
      background-color: #3B2854;

      &-text {
        margin: 0 $gap * 2.5;

        @include display-less(desktop) {
          margin: 0 $gap * 1.5;
        }
      }

      &-image {
        max-width: 540px;
        width: 100%;
        margin: 0 auto;
      }
    }

    &-inverted-item {
      flex-direction: column-reverse;
    }

    &-horizontal-item {
      flex-direction: row-reverse;
      align-items: center;
      grid-column: span 2;

      @include display-less(desktop) {
        flex-direction: column-reverse;
        gap: $gap * 2.5;
      }

      > .grid__list-item-text {
        margin-left: 0;

        @include display-less(desktop) {
          margin: 0 $gap * 1.5;
        }
      }
    }
  }
}
</style>
